import { useTranslation } from 'react-i18next';

import ConstellationArt from './ConstellationArt';
import { firstSentence, ordinal } from './chartGeometry';
import styles from './styles.module.scss';

const LifeThemeCard = ({ theme, index = 0 }) => {
    const { t } = useTranslation();
    const meta = [theme.house ? t('birthChart.view.chart.houseLabel', { ordinal: ordinal(theme.house) }) : '', theme.sign]
        .filter(Boolean)
        .join(' · ');

    return (
        <article className={styles.themeCard}>
            <ConstellationArt seed={index} />
            <h4 className={styles.themeTitle}>{theme.title}</h4>
            <p className={styles.themeCopy}>{firstSentence(theme.copy)}</p>
            {meta && <p className={styles.themeMeta}>{meta}</p>}
        </article>
    );
};

export default LifeThemeCard;
